import { Component } from 'react'
import styled from '@emotion/styled'
import { Image, Box, RoundedLabel, Icons, ItemInfoModal, Spacer } from 'stylewhere/components'
import { Products, TmrItem } from 'stylewhere/api'
import { T, __ } from 'stylewhere/i18n'
import { AppStore } from 'stylewhere/shared'

interface Props {
  id: any
  item: TmrItem
  onInfoPress?: (item: TmrItem) => void
  onDeleteCallback?: (item: TmrItem) => void
}

interface State {
  visibleItemModal: boolean
}

export class ItemRow extends Component<Props, State> {
  state: State = {
    visibleItemModal: false,
  }

  openItemInfoModal = () => this.setState({ visibleItemModal: true })
  closeItemInfoModal = () => this.setState({ visibleItemModal: false })

  onRowPress = () => {
    const { onInfoPress, item } = this.props
    if (onInfoPress) return () => onInfoPress(item)
    if (!item.id) return undefined
    if (!onInfoPress) return this.openItemInfoModal
    return undefined
  }

  getItemMessage = () => {
    const { item } = this.props
    const messages: string[] = []
    if (item.statuses?.find((status) => status === 'ITEM_NOT_IN_INBOUND')) {
      messages.push(__(T.error.item_not_in_inbound))
    }
    if (item.statuses?.find((status) => status === 'ITEM_NOT_IN_STOCK')) {
      messages.push(__(T.error.item_not_in_stock))
    }
    if (item.statuses?.find((status) => status === 'ITEM_IN_ANOTHER_PARCEL')) {
      messages.push(__(T.error.item_in_another_parcel))
    }
    if (item.statuses?.find((status) => status === 'ITEM_IN_ANOTHER_PRODUCTION_ORDER')) {
      messages.push(__(T.error.item_in_another_production_order))
    }
    if (messages.length === 0) return undefined

    return messages.join()
  }

  onDeletePress = () => {
    const { onDeleteCallback, item } = this.props
    if (onDeleteCallback) return () => onDeleteCallback(item)
    return undefined
  }

  render() {
    const { item, id, onDeleteCallback } = this.props
    const { visibleItemModal } = this.state
    if (!item) return <></>
    const { product } = item

    let tagType
    if (!item.product) tagType = __(T.misc.unknown_product)
    // if (!item.product && item.upc) tagType = __(T.misc.unknown_tag)
    // if (!item.upc && !item.product) tagType = __(T.misc.invalid_tag)

    const upc = item.product?.code

    let status: 'error' | 'warning' | undefined = item.__processedStatuses?.find((state) => state === 'WARNING')
      ? 'warning'
      : undefined
    status = item.__processedStatuses?.find((state) => state === 'ERROR') ? 'error' : undefined

    const message = this.getItemMessage()

    return (
      <Row data-testid={`item-row`} row id={id} onClick={onDeleteCallback ? undefined : this.onRowPress()}>
        {AppStore.getShowProductImage() && (
          <Box center p={10}>
            <ProductImage src={Products.getImageUrl(product)} alt="item" />
          </Box>
        )}

        {AppStore.getShowProductImage() && <Separator />}

        <Box flex p={20} pr={0}>
          <Box style={{ maxWidth: 'fit-content', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            <ProductCode>{upc ?? __(T.misc.unknown).toUpperCase()}</ProductCode>
            <ItemEpc>{item.product?.description}</ItemEpc>
            {/* {item.itemIdentifiers.map((idf) => (
              <ItemEpc>
                {idf.identifierType}: {idf.code}
              </ItemEpc>
            ))} */}
          </Box>
          <Spacer />
          <Box row style={{ justifyContent: 'flex-start' }}>
            <RoundedLabel maxWidth={230} label={__(T.misc.style)} value={product?.style?.description} />
            <RoundedLabel maxWidth={130} label={__(T.misc.size)} value={product?.size?.value} />
            <RoundedLabel maxWidth={150} label={__(T.misc.color)} value={product?.color?.value} />
            <RoundedLabel value={tagType?.toUpperCase()} />
          </Box>
          {!!message && (
            <Box row style={{ justifyContent: 'flex-start' }}>
              <Message status={status}>{message}</Message>
            </Box>
          )}
        </Box>
        {onDeleteCallback && (
          <Box p={30} center onClick={this.onDeletePress()}>
            <Icons.Delete />
          </Box>
        )}
        {!!this.onRowPress() && !onDeleteCallback && (
          <Box p={30} center>
            <Icons.Info />
          </Box>
        )}
        {visibleItemModal && (
          <ItemInfoModal visible={visibleItemModal} itemId={item.id} onClose={this.closeItemInfoModal} />
        )}
      </Row>
    )
  }
}

const Row = styled(Box)`
  margin-bottom: 20px;
  border: 2px solid #edecec;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
`

const Separator = styled.div`
  width: 2px;
  height: 100%;
  background-color: #edecec;
`

const ProductImage = styled(Image)`
  width: 100px;
  height: 100px;
  padding: 10px;
`

const ProductCode = styled.div`
  font-weight: 900;
  font-size: 28px;
`

const ItemEpc = styled.div`
  font-weight: 400;
  font-size: 20px;
`

const Message = styled.div<{ status?: 'error' | 'warning' }>`
  font-weight: 400;
  font-size: 20px;
  color: ${({ status, theme }) => {
    switch (status) {
      case 'warning':
        return '#FBBF66'
      case 'error':
        return '#FD7575'
      default:
        return theme.foreground
    }
  }};
`
